import React from 'react';

import {
  SliderContainer,
  SliderTrack,
  SliderFill,
  SliderHandle,
  SliderSection,
  LabelRow
} from '../style';

function ProgressSlider({ statusColors, configuredCount = 0 }) {
  const mapColorToSliderColor = (color) => {
    switch (color?.toUpperCase()) {
      case '#08AA15':
        return '#8CF295';
      case '#F53D4C':
        return '#F76E79';
      case '#F0AD4E':
        return '#FFE484';
      default:
        return '#D0D3E2';
    }
  };

  const percentage = (configuredCount / 3) * 100;

  return (
    <SliderContainer>
      <SliderTrack>
        <SliderFill>
          <SliderSection
            flex="1"
            color={mapColorToSliderColor(statusColors?.operacao)}
          />
          <SliderSection
            flex="1"
            color={mapColorToSliderColor(statusColors?.analise)}
          />
          <SliderSection
            flex="1"
            color={mapColorToSliderColor(statusColors?.evolucao)}
          />
        </SliderFill>
        {percentage < 100 && percentage > 0 && (
          <SliderHandle
            style={{ left: `calc(clamp(0.5%, ${percentage}%, 99.5%) - 5px)` }}
          />
        )}
      </SliderTrack>

      <LabelRow>
        <span>Operação</span>
        <span>Análise</span>
        <span>Evolução</span>
      </LabelRow>
    </SliderContainer>
  );
}

export default ProgressSlider;
